import { createContext, useContext } from "react";

export const VOICE_STATES = {
  IDLE: "IDLE",                         // Inactive floating orb
  ACTIVATING: "ACTIVATING",             // Initializing audio / requesting mic permission
  LISTENING: "LISTENING",               // Streaming live PCM audio to Sarvam Realtime STT
  UNDERSTANDING: "UNDERSTANDING",       // Sarvam VAD finalized; intent parsing
  EXECUTING: "EXECUTING",               // Website action executing
  RESPONDING: "RESPONDING",             // Action finished, preparing feedback
  SPEAKING: "SPEAKING",                 // TTS audio playing back through speakers
  ERROR: "ERROR",                       // Graceful error state

  // Aliases for compatibility
  WAKE_DETECTED: "LISTENING",
  TRANSCRIBING: "TRANSCRIBING",       // Waiting for final transcript from server
  THINKING: "UNDERSTANDING",
  PROCESSING: "UNDERSTANDING",
  LISTENING_FOR_WAKE_WORD: "IDLE",
  LISTENING_FOR_COMMAND: "LISTENING"
};

export const VoiceContext = createContext(null);

export const useVoice = () => {
  const context = useContext(VoiceContext);
  if (!context) {
    throw new Error("useVoice must be used within a VoiceProvider");
  }
  return context;
};

export default VoiceContext;
